<template>
  <ScrollArea>
    <div
      v-if="accessDenied2" >
      <h1 class="settings__title">
        Organisation permissions
      </h1>
      <Forbidden />
    </div>
    <div
      v-else-if="!forbidden"
      class="settings--limit-width">
      <h1 class="settings__title">
        Organisation permissions
      </h1>

      <SettingsNote
        :icon="SBIconList.LOCK_OPEN"
        title="Admins have a permission to view any page or do any action."
        sub="" />

      <!-- TODO - permissions hidden for now -->
      <!-- Choose who can  manage subscriber lists - permissionRoles.manage_lists -->
      <!-- Choose who can send campaign notifications - permissionRoles.send_bulk_messages -->

      <Spinner
        v-if="!permissionRolesLoaded || !initialized"
        class="mt-5"
        :thickness="2" />

      <template v-else>
        <ValidationObserver
          ref="customFieldObserver"
          v-slot="{ valid, dirty, pristine }" >

          <h2 class="settings__subtitle">Conversations</h2>
          <b-form-group>
            <label
              for=""
              class="settings__label-sub" >
              Choose who can view conversations assigned to other team members
            </label>
            <ValidationProvider
              v-slot="{ errors }"
              rules="required">
              <multiselect
                v-model="permissionRoleChanges.list_others_assigned_conversations"
                placeholder="Select an option"
                class="flex-options hide-tags no-selected-background"
                :options="roles"
                label="text"
                track-by="value"
                :multiple="true"
                :show-labels="false"
                :show-no-results="false"
                :close-on-select="false"
                :clear-on-select="false"
                :preserve-search="true"
                :allow-empty="true"
                :searchable="false" >
                <template
                  slot="selection"
                  slot-scope="{ values }">
                  <span
                    v-if="values.length"
                    class="multiselect__single" >{{ formatPermissionValues(values) }}</span>
                </template>
                <template
                  slot="option"
                  slot-scope="props">
                  <SBIcon
                    :icon="SBIconList.DONE_TICK"
                    :color="SBColors.bluePrimary"
                    :size="9"/>
                  {{ props.option.text }}
                </template>
              </multiselect>
              <div
                v-if="errors[0]"
                class="error flex flex-align-center">
                <SBIcon
                  class="mr-2"
                  :icon="SBIconList.ERROR"
                  :color="SBColors.redPrimary"
                  :size="12" />
                <span>Required field</span>
              </div>
            </ValidationProvider>
          </b-form-group>

          <b-form-group>
            <label
              for=""
              class="settings__label-sub" >
              Choose who can view unassigned conversations
            </label>
            <ValidationProvider
              v-slot="{ errors }"
              rules="required">
              <multiselect
                v-model="permissionRoleChanges.list_unassigned_conversations"
                placeholder="Select an option"
                class="flex-options hide-tags no-selected-background"
                :options="roles"
                label="text"
                track-by="value"
                :multiple="true"
                :show-labels="false"
                :show-no-results="false"
                :close-on-select="false"
                :clear-on-select="false"
                :preserve-search="true"
                :allow-empty="true"
                :searchable="false" >
                <template
                  slot="selection"
                  slot-scope="{ values }">
                  <span
                    v-if="values.length"
                    class="multiselect__single" >{{ formatPermissionValues(values) }}</span>
                </template>
                <template
                  slot="option"
                  slot-scope="props">
                  <SBIcon
                    :icon="SBIconList.DONE_TICK"
                    :color="SBColors.bluePrimary"
                    :size="9"/>
                  {{ props.option.text }}
                </template>
              </multiselect>
              <div
                v-if="errors[0]"
                class="error flex flex-align-center">
                <SBIcon
                  class="mr-2"
                  :icon="SBIconList.ERROR"
                  :color="SBColors.redPrimary"
                  :size="12" />
                <span>Required field</span>
              </div>
            </ValidationProvider>
          </b-form-group>

          <b-form-group>
            <label
              for=""
              class="settings__label-sub" >
              Choose who can assign conversations to other team members
            </label>
            <ValidationProvider
              v-slot="{ errors }"
              rules="required">
              <multiselect
                v-model="permissionRoleChanges.assign_conversations"
                placeholder="Select an option"
                class="flex-options hide-tags no-selected-background"
                :options="roles"
                label="text"
                track-by="value"
                :multiple="true"
                :show-labels="false"
                :show-no-results="false"
                :close-on-select="false"
                :clear-on-select="false"
                :preserve-search="true"
                :allow-empty="true"
                :searchable="false" >
                <template
                  slot="selection"
                  slot-scope="{ values }">
                  <span
                    v-if="values.length"
                    class="multiselect__single" >{{ formatPermissionValues(values) }}</span>
                </template>
                <template
                  slot="option"
                  slot-scope="props">
                  <SBIcon
                    :icon="SBIconList.DONE_TICK"
                    :color="SBColors.bluePrimary"
                    :size="9"/>
                  {{ props.option.text }}
                </template>
              </multiselect>
              <div
                v-if="errors[0]"
                class="error flex flex-align-center">
                <SBIcon
                  class="mr-2"
                  :icon="SBIconList.ERROR"
                  :color="SBColors.redPrimary"
                  :size="12" />
                <span>Required field</span>
              </div>
            </ValidationProvider>
          </b-form-group>

          <h2 class="settings__subtitle">WhatsApp Message Templates</h2>

          <b-form-group>
            <label
              for=""
              class="settings__label-sub" >
              Choose who can add and delete WhatsApp Message Templates
            </label>
            <ValidationProvider
              v-slot="{ errors }"
              rules="required">
              <multiselect
                v-model="permissionRoleChanges.manage_template_messages"
                placeholder="Select an option"
                class="flex-options hide-tags no-selected-background"
                :options="roles"
                label="text"
                track-by="value"
                :multiple="true"
                :show-labels="false"
                :show-no-results="false"
                :close-on-select="false"
                :clear-on-select="false"
                :preserve-search="true"
                :allow-empty="true"
                :searchable="false" >
                <template
                  slot="selection"
                  slot-scope="{ values }">
                  <span
                    v-if="values.length"
                    class="multiselect__single" >{{ formatPermissionValues(values) }}</span>
                </template>
                <template
                  slot="option"
                  slot-scope="props">
                  <SBIcon
                    :icon="SBIconList.DONE_TICK"
                    :color="SBColors.bluePrimary"
                    :size="9"/>
                  {{ props.option.text }}
                </template>
              </multiselect>
              <div
                v-if="errors[0]"
                class="error flex flex-align-center">
                <SBIcon
                  class="mr-2"
                  :icon="SBIconList.ERROR"
                  :color="SBColors.redPrimary"
                  :size="12" />
                <span>Required field</span>
              </div>
            </ValidationProvider>
          </b-form-group>

          <b-form-group>
            <label
              for=""
              class="settings__label-sub" >
              Choose who can send WhatsApp Message Templates
            </label>
            <ValidationProvider
              v-slot="{ errors }"
              rules="required">
              <multiselect
                v-model="permissionRoleChanges.send_notifications"
                placeholder="Select an option"
                class="flex-options hide-tags no-selected-background"
                :options="roles"
                label="text"
                track-by="value"
                :multiple="true"
                :show-labels="false"
                :show-no-results="false"
                :close-on-select="false"
                :clear-on-select="false"
                :preserve-search="true"
                :allow-empty="true"
                :searchable="false" >
                <template
                  slot="selection"
                  slot-scope="{ values }">
                  <span
                    v-if="values.length"
                    class="multiselect__single" >{{ formatPermissionValues(values) }}</span>
                </template>
                <template
                  slot="option"
                  slot-scope="props">
                  <SBIcon
                    :icon="SBIconList.DONE_TICK"
                    :color="SBColors.bluePrimary"
                    :size="9"/>
                  {{ props.option.text }}
                </template>
              </multiselect>
              <div
                v-if="errors[0]"
                class="error flex flex-align-center">
                <SBIcon
                  class="mr-2"
                  :icon="SBIconList.ERROR"
                  :color="SBColors.redPrimary"
                  :size="12" />
                <span>Required field</span>
              </div>
            </ValidationProvider>
          </b-form-group>

          <h2 class="settings__subtitle">Contacts</h2>

          <!-- TODO - not implemented on BE yet -->
          <!-- <b-form-group>
            <label
              for=""
              class="settings__label-sub" >
              Choose who can view contacts
            </label>
            <multiselect
              v-model="permissionRoleChanges._________________________"
              placeholder="Select an option"
              class="flex-options hide-tags no-selected-background"
              :options="roles"
              label="text"
              track-by="value"
              :multiple="true"
              :show-labels="false"
              :show-no-results="false"
              :close-on-select="false"
              :clear-on-select="false"
              :preserve-search="true"
              :allow-empty="true"
              :searchable="false" >
              <template
                slot="selection"
                slot-scope="{ values }">
                <span
                  v-if="values.length"
                  class="multiselect__single" >{{ formatPermissionValues(values) }}</span>
              </template>
              <template
                slot="option"
                slot-scope="props">
                <SBIcon
                  :icon="SBIconList.LOCK_OPEN"
                  :color="SBColors.bluePrimary"
                  :size="14"/>
                {{ props.option.text }}
              </template>
            </multiselect>
          </b-form-group> -->

          <b-form-group>
            <label
              for=""
              class="settings__label-sub" >
              Choose who can view contacts list
            </label>
            <ValidationProvider
              v-slot="{ errors }"
              rules="required">
              <multiselect
                v-model="permissionRoleChanges.can_view_all_contacts"
                placeholder="Select an option"
                class="flex-options hide-tags no-selected-background"
                :options="roles"
                label="text"
                track-by="value"
                :multiple="true"
                :show-labels="false"
                :show-no-results="false"
                :close-on-select="false"
                :clear-on-select="false"
                :preserve-search="true"
                :allow-empty="true"
                :searchable="false" >
                <template
                  slot="selection"
                  slot-scope="{ values }">
                  <span
                    v-if="values.length"
                    class="multiselect__single" >{{ formatPermissionValues(values) }}</span>
                </template>
                <template
                  slot="option"
                  slot-scope="props">
                  <SBIcon
                    :icon="SBIconList.DONE_TICK"
                    :color="SBColors.bluePrimary"
                    :size="9"/>
                  {{ props.option.text }}
                </template>
              </multiselect>
              <div
                v-if="errors[0]"
                class="error flex flex-align-center">
                <SBIcon
                  class="mr-2"
                  :icon="SBIconList.ERROR"
                  :color="SBColors.redPrimary"
                  :size="12" />
                <span>Required field</span>
              </div>
            </ValidationProvider>
          </b-form-group>

          <b-form-group>
            <label
              for=""
              class="settings__label-sub" >
              Choose who can add and delete contacts
            </label>
            <ValidationProvider
              v-slot="{ errors }"
              rules="required">
              <multiselect
                v-model="permissionRoleChanges.can_add_contact"
                placeholder="Select an option"
                class="flex-options hide-tags no-selected-background"
                :options="roles"
                label="text"
                track-by="value"
                :multiple="true"
                :show-labels="false"
                :show-no-results="false"
                :close-on-select="false"
                :clear-on-select="false"
                :preserve-search="true"
                :allow-empty="true"
                :searchable="false" >
                <template
                  slot="selection"
                  slot-scope="{ values }">
                  <span
                    v-if="values.length"
                    class="multiselect__single" >{{ formatPermissionValues(values) }}</span>
                </template>
                <template
                  slot="option"
                  slot-scope="props">
                  <SBIcon
                    :icon="SBIconList.DONE_TICK"
                    :color="SBColors.bluePrimary"
                    :size="9"/>
                  {{ props.option.text }}
                </template>
              </multiselect>
              <div
                v-if="errors[0]"
                class="error flex flex-align-center">
                <SBIcon
                  class="mr-2"
                  :icon="SBIconList.ERROR"
                  :color="SBColors.redPrimary"
                  :size="12" />
                <span>Required field</span>
              </div>
            </ValidationProvider>
          </b-form-group>

          <b-form-group>
            <label
              for=""
              class="settings__label-sub" >
              Choose who can edit contact info
            </label>
            <ValidationProvider
              v-slot="{ errors }"
              rules="required">
              <multiselect
                v-model="permissionRoleChanges.can_edit_contact"
                placeholder="Select an option"
                class="flex-options hide-tags no-selected-background"
                :options="roles"
                label="text"
                track-by="value"
                :multiple="true"
                :show-labels="false"
                :show-no-results="false"
                :close-on-select="false"
                :clear-on-select="false"
                :preserve-search="true"
                :allow-empty="true"
                :searchable="false" >
                <template
                  slot="selection"
                  slot-scope="{ values }">
                  <span
                    v-if="values.length"
                    class="multiselect__single" >{{ formatPermissionValues(values) }}</span>
                </template>
                <template
                  slot="option"
                  slot-scope="props">
                  <SBIcon
                    :icon="SBIconList.DONE_TICK"
                    :color="SBColors.bluePrimary"
                    :size="9"/>
                  {{ props.option.text }}
                </template>
              </multiselect>
              <div
                v-if="errors[0]"
                class="error flex flex-align-center">
                <SBIcon
                  class="mr-2"
                  :icon="SBIconList.ERROR"
                  :color="SBColors.redPrimary"
                  :size="12" />
                <span>Required field</span>
              </div>
            </ValidationProvider>
          </b-form-group>

          <h2 class="settings__subtitle">Activity</h2>

          <b-form-group>
            <label
              for=""
              class="settings__label-sub" >
              Choose who can view activities
            </label>
            <ValidationProvider
              v-slot="{ errors }"
              rules="required">
              <multiselect
                v-model="permissionRoleChanges.view_analytics"
                placeholder="Select an option"
                class="flex-options hide-tags no-selected-background"
                :options="roles"
                label="text"
                track-by="value"
                :multiple="true"
                :show-labels="false"
                :show-no-results="false"
                :close-on-select="false"
                :clear-on-select="false"
                :preserve-search="true"
                :allow-empty="true"
                :searchable="false" >
                <template
                  slot="selection"
                  slot-scope="{ values }">
                  <span
                    v-if="values.length"
                    class="multiselect__single" >{{ formatPermissionValues(values) }}</span>
                </template>
                <template
                  slot="option"
                  slot-scope="props">
                  <SBIcon
                    :icon="SBIconList.DONE_TICK"
                    :color="SBColors.bluePrimary"
                    :size="9"/>
                  {{ props.option.text }}
                </template>
              </multiselect>
              <div
                v-if="errors[0]"
                class="error flex flex-align-center">
                <SBIcon
                  class="mr-2"
                  :icon="SBIconList.ERROR"
                  :color="SBColors.redPrimary"
                  :size="12" />
                <span>Required field</span>
              </div>
            </ValidationProvider>
          </b-form-group>

          <!-- TODO - not implemented on BE yet -->
          <h2 class="settings__subtitle">Number settings</h2>

          <b-form-group>
            <label
              for=""
              class="settings__label-sub" >
              Choose who can edit number settings
            </label>
            <ValidationProvider
              v-slot="{ errors }"
              rules="required">
              <multiselect
                v-model="permissionRoleChanges.manage_settings"
                placeholder="Select an option"
                class="flex-options hide-tags no-selected-background"
                :options="roles"
                label="text"
                track-by="value"
                :multiple="true"
                :show-labels="false"
                :show-no-results="false"
                :close-on-select="false"
                :clear-on-select="false"
                :preserve-search="true"
                :allow-empty="true"
                :searchable="false" >
                <template
                  slot="selection"
                  slot-scope="{ values }">
                  <span
                    v-if="values.length"
                    class="multiselect__single" >{{ formatPermissionValues(values) }}</span>
                </template>
                <template
                  slot="option"
                  slot-scope="props">
                  <SBIcon
                    :icon="SBIconList.DONE_TICK"
                    :color="SBColors.bluePrimary"
                    :size="9"/>
                  {{ props.option.text }}
                </template>
              </multiselect>
              <div
                v-if="errors[0]"
                class="error flex flex-align-center">
                <SBIcon
                  class="mr-2"
                  :icon="SBIconList.ERROR"
                  :color="SBColors.redPrimary"
                  :size="12" />
                <span>Required field</span>
              </div>
            </ValidationProvider>
          </b-form-group>

          <div
            v-if="errorMessage"
            class="error-message">
            {{ errorMessage }}
          </div>

          <FooterActions
            :form-valid="valid"
            :has-changes="dirty"
            :show-cancel="!pristine"
            :save-busy="saving"
            @reset="resetChanges"
            @save="updateMerchantPermissions" />
        </ValidationObserver>
      </template>

    </div>
  </ScrollArea>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Multiselect from 'vue-multiselect';
import { extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';

import ToasterMixin from '@/mixins/Toaster';
import Spinner from '../../common/Spinner';
import FooterActions from './partials/FooterActions';
import SettingsNote from './partials/SettingsNote';
import ScrollArea from '@/components/common/ScrollArea';
import NoPermissionMixin from '@/mixins/AccessPermission';
import UserPermissionsMixin from '@/mixins/UserPermissions.mixin';

// Permissions
// 1 manage_settings
// 2 manage_automation
// 3 manage_contacts
// 4 view_analytics
// 5 manage_invoices
// 6 view_invoices
// 7 manage_lists
// 8 manage_template_messages
// 9 send_notifications
// 10 send_bulk_messages

// Roles
// 1 owner
// 2 admin
// 3 team_lead
// 4 member

extend('required', required);

export default {
  name: 'PermissionSettings',
  components: {
    FooterActions,
    Multiselect,
    Spinner,
    SettingsNote,
    ScrollArea,
  },
  mixins: [
    ToasterMixin,
    NoPermissionMixin,
    UserPermissionsMixin,
  ],
  data() {
    return {
      roles: [
        {
          text: 'Admin',
          value: 'admin',
        },
        {
          text: 'Team Lead',
          value: 'team_lead',
        },
        {
          text: 'Member',
          value: 'member',
        },
      ],
      saving: false,
      errorMessage: '',
      permissionRoleChanges: {},
      tempSavingRoles: null,
      initialized: false,
      forbidden: false,
    };
  },
  computed: {
    ...mapGetters({
      permissionRoles: 'merchant/permissionRoles',
      permissionRolesLoaded: 'merchant/permissionRolesLoaded',
      permissionRolesUpdated: 'merchant/permissionRolesUpdated',
      apiError: 'merchant/apiError',
    }),
    accessDenied2() {
      return this.forbidden || !this.checkPermission('manage_organisation_settings');
    },
    /** Test the change on the model with the last save data and disables the button if they are the same. */
    testIfFormChanged() {
      const originalPermissions = {};
      const editedPermissions = {};
      const latestOriginalData = this.tempSavingRoles ? this.tempSavingRoles : this.permissionRoles;
      const permissionsAvailableOnOriginal = Object.keys(latestOriginalData);
      permissionsAvailableOnOriginal.forEach((permission) => {
        originalPermissions[permission] = latestOriginalData[permission].map(item => item).sort();
      });
      const permissionsAvailableOnEdited = Object.keys(this.permissionRoleChanges);
      permissionsAvailableOnEdited.forEach((permission) => {
        editedPermissions[permission] = this.permissionRoleChanges[permission].map(item => item.value).sort();
      });
      return this.$lodash.isEqual({ ...originalPermissions }, { ...editedPermissions });
    },
  },
  watch: {
    accessDenied2() {
      if (!this.accessDenied2) {
        this.fetchPermissionRoles();
      }
    },
    apiError(error) {
      this.saving = false;
      this.errorMessage = error.data.message;
    },
    permissionRolesUpdated(updated) {
      if (updated) {
        this.saving = false;

        this.showToaster('Permissions have been successfully updated.', null, null, 'OK');
        this.$refs.customFieldObserver.reset();
      }
    },
    permissionRolesLoaded() {
      this.initialized = true;
      this.resetChanges();
    },
    // Since we are not using the testIfFormChanged computed anywhere in the code it doesn't get computed so we have to watch on it.
    // Also we can't watch on permissionRoleChanges because it is not reactive since we add the keys dinamically. Even if we add the keys with $set method it is still not dynamic since it won't react on array changes.
    // That is why we need this weird construction of computed which reacts to all the changes which we then react to in the watch section.
    testIfFormChanged() {
      if (this.testIfFormChanged && this.$refs.customFieldObserver) {
        this.$refs.customFieldObserver.reset();
      }
    },
  },
  mounted() {
    // Fix this on rewrite - user data should be preloaded on app load so we shuldn't need to wait for data update to know user role
    setTimeout(() => {
      if (!this.accessDenied2 && this.currentOrganisation.id) {
        this.fetchPermissionRoles();
      }
      this.finalizeSplashView();
    }, 1000);

    window.eventBus.$on('403', () => { this.forbidden = true; });
  },
  methods: {
    ...mapActions({
      fetchPermissionRoles: 'merchant/fetchPermissionRoles',
      updatePermissions: 'merchant/updatePermissions',
      finalizeSplashView: 'organisation/finalizeSplashView',
    }),
    resetChanges() {
      const latestOriginalData = this.tempSavingRoles ? this.tempSavingRoles : this.permissionRoles;
      const permissions = Object.keys(latestOriginalData);
      permissions.forEach((permission) => {
        this.$set(this.permissionRoleChanges, permission, []);
        latestOriginalData[permission].forEach((permissionRole) => {
          const permissionRoleIndex = this.roles.findIndex(role => role.value === permissionRole);
          this.$set(this.permissionRoleChanges[permission], this.permissionRoleChanges[permission].length, this.roles[permissionRoleIndex]);
        });
      });
      if (this.$refs.customFieldObserver) {
        this.$refs.customFieldObserver.reset();
      }
    },
    updateMerchantPermissions() {
      this.saving = true;
      this.errorMessage = '';

      const permissionToSend = {};

      const permissions = Object.keys(this.permissionRoleChanges);
      permissions.forEach((permission) => {
        permissionToSend[permission] = this.permissionRoleChanges[permission].map(item => item.value);
      });

      // DELETE and ADD values must be the same unless we decide to make separate dropdowns for this option.
      permissionToSend.can_delete_contact = this.permissionRoleChanges.can_add_contact.map(item => item.value);

      const payload = {
        data: {
          permissions: permissionToSend,
        },
      };
      this.tempSavingRoles = { ...permissionToSend };
      this.updatePermissions(payload);
    },
    formatPermissionValues(values) {
      let value = '';

      if (values.length === this.roles.length) {
        value = 'All roles';
      } else if (values.length > 2) {
        // CS - join with "and" at the end
        const tmpLast = values[values.length - 1].text;
        const tmpUpToLast = [...values].splice(0, values.length - 1).map(value => value.text);
        value = tmpUpToLast.join(', ');
        value = `${value} and ${tmpLast}`;
      } else if (values.length) {
        value = values.map(value => value.text).join(' and ');
      }
      return value;
    },
    isSelected(value, values) {
      return values ? values.includes(value) : false;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  ul.multiselect__content {
    li.multiselect__element:first-of-type {
      pointer-events: none; // prevents user to unselect admin
      opacity: 0.7;
      color: $lightGray;
      // display: none;     // hides admin option - comment this and uncomment surounding properties for a disabled option
      cursor: default !important;

      span.multiselect__option, span.multiselect__option--selected {
        // Can't override it from here since a more specific selector is needed.
        // Check the override a few lines below.
      }
    }
  }

  .multiselect.no-selected-background .multiselect__content-wrapper .multiselect__content
    .multiselect__element:first-of-type .multiselect__option.multiselect__option--selected {
      color: $blackLight !important;

      .sb-icon .mask {
        --color: #{$blackLight} !important;
      }
    }
}
</style>
